import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBasicProfile = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 16,
		cy: 16,
		r: 16,
		fill: "#C4C8D0"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M4.00391 26.5865C5.58502 23.401 8.8711 21.2114 12.6686 21.2114H18.9779C22.8769 21.2114 26.2368 23.5197 27.7657 26.8442C24.8422 30.0143 20.6535 32 16.0011 32C11.2239 32 6.93561 29.9063 4.00391 26.5865ZM21.0009 14C21.0009 16.7614 18.7624 19 16.0009 19C13.2395 19 11.0009 16.7614 11.0009 14C11.0009 11.2386 13.2395 9 16.0009 9C18.7624 9 21.0009 11.2386 21.0009 14Z",
		fill: "white"
	})]
});
export default SvgBasicProfile;
